const { forwardRef, useCallback } = require('react');
const T = require('prop-types');
const { default: Avatar } = require('@mui/material/Avatar');
const { useProfileImage, useProfileImageVisibility } = require('../../hooks/useProfileImage');

module.exports = forwardRef(ProfileAvatar);

function ProfileAvatar({ src, srcSet, imgProps = {}, eager = false, alt = '', children, ...other }, forwardedRef) {

    const { ref, inView } = useProfileImageVisibility(eager);
    const image = useProfileImage(src, { enabled: eager || inView });
    const setRef = useCallback((element) => {

        ref(element);
        if (typeof forwardedRef === 'function') {
            forwardedRef(element);
        }
        else if (forwardedRef) {
            forwardedRef.current = element;
        }
    }, [ref, forwardedRef]);

    return (
        <Avatar
            {...other}
            ref={setRef}
            alt={alt}
            src={image.src || undefined}
            srcSet={image.src === src ? srcSet : undefined}
            imgProps={{
                ...imgProps,
                srcSet: image.src === src ? imgProps.srcSet : undefined,
                onError: (event) => {

                    image.onError();
                    imgProps.onError?.(event);
                }
            }}
        >
            {children ?? (src && alt ? alt[0] : undefined)}
        </Avatar>
    );
}

ProfileAvatar.propTypes = {
    src: T.oneOfType([T.string, T.bool]),
    srcSet: T.string,
    alt: T.string,
    imgProps: T.object,
    eager: T.bool,
    children: T.node
};
